import { IRequestType } from '../../../APIPackage/SmevMessagesModule/interfaces/IRequestType';

export interface ISmevMessageTypeOption extends IRequestType {
  label: string;
  value: string;
}

export function createSmevMessageTypeOption(requestType: IRequestType): ISmevMessageTypeOption {
  const messageType = requestType.messageType ?? '';

  return {
    ...requestType,
    messageType,
    label: messageType,
    value: messageType,
  };
}
